import FetchList from '../models/FetchList'

export default function () {
  document.querySelectorAll('.fetch-list').forEach(list => {
    /* eslint-disable-next-line no-new */
    new FetchList(list)
  })
}



// WEBPACK FOOTER //
// ./themes/default/js/modules/fetchLists.js